import request from '@/util/request';

export interface EcCompanyInfo {
  /**
   * 桩企id
   */
  companyId: number;
  /**
   * 桩企名称
   */
  companyName: string;
  /**
   * 桩企简称
   */
  company_name_short: string;
  /**
   * 联络人
   */
  linkman: string;
  /**
   * 联络方式
   */
  linkPhoneNum: string;
  /**
   * 所在地区
   */
  area: string;
  /**
   * 邮箱
   */
  businessEmail: string;
  /**
   * 注册时间
   */
  registerTime: string;
  license: string;
  creditProve: string;
  qualitySystem: string;
  supplyContract: string;
  invoice: string;
  rentContract: string;
  electricalEngineerContract: string;
  structuralEngineerContract: string;
  softwareEngineerContract: string;
  regulatoryRegimeFiles: string;
  operateProcess: string;
  testStandard: string;
  initialData: string;
  equipmentPhoto: string;
  equipmentInspectionCertificate: string;
  opsManual: string;
  standingBook: string;
  firstAuditTime: string;
  lastAuditTime: string;
  auditor: string;
  /**
   * -1 未提交
   * 0: 审核中
   * 1: 通过
   * 2: 未通过
   */
  auditState: -1 | 0 | 1 | 2;
  auditInfo: string;
}


export const submitApplyInfo = async (params: EcCompanyInfo) => {
  const res = await request('/ec-manage/company/update', {
    method: 'POST',
    body: params,
  });
  return res as boolean;
}

interface UploadResponse {
  status: string;
  download_url: string;
  download_url_https: string;
  md5: string;
  file_size: number;
  creation_time: number;
  resource_key: string;
  error_code: string;
  message: string;
}

interface UploadParams {
  name: string;
  file: string;
  suffix: string;
}

export const upload = async (params: UploadParams) => {
  const res = await request('/ec-manage/uploadImg', {
    method: 'POST',
    body: params,
  });
  return res as UploadResponse;
}

export const getCompanyInfo = async (params: Partial<EcCompanyInfo> = {}) => {
  const res = await request('/ec-manage/company/queryByCondition', {
    method: 'POST',
    body: params,
  });
  return res as EcCompanyInfo[];
}

export interface EcAuditSnapshot {
  id: number;
  auditType: number;
  auditResult: number;
  auditDetail: string;
  companyId: string;
  companyName: string;
  produceName: string;
  auditor: string;
  auditorPhone: string;
  auditorInfo: string;
  applicant: string;
  applicantPhone: string;
  submitTime: number;
  updateTime: number;
  message: string;
}

export const queryAuditInfoByCompanyId = async (id: string) => {
  const res = await request('/ec-manage/audit/queryAuditInfoByCompanyId', {
    method: 'POST',
    body: id,
  });
  return res as EcAuditSnapshot[];
}

